import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './PointActionsSlider.module.sass';
import './SlickOverrides.sass';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';
import arrowLeftMobileIcon from '../../../../images/pages/the_lounge/arrow-left-mobile.svg';

const MOBILE_SLIDES_COUNT = 2;

function PointActionsSlider(props) {
  const { pointActions, pointActionWrapper: PointActionWrapper } = props;
  const mobileSliderRef = useRef(null);

  const onLeftArrowClick = () => {
    mobileSliderRef.current.slickPrev();
  };

  const onRightArrowClick = () => {
    mobileSliderRef.current.slickNext();
  };

  const [clickedByActionId, setClickedByActionId] = useState({});
  const [codeByActionId, setCodeByActionId] = useState({});
  const [loadingByActionId, setLoadingByActionId] = useState({});
  const [birthday, setBirthday] = useState('');

  const isClicked = (id) => clickedByActionId[id] || false;
  const setClicked = (id, value) => {
    const newClickedByActionId = { ...clickedByActionId };
    newClickedByActionId[id] = value;
    setClickedByActionId(newClickedByActionId);
  };

  const setCode = (id, value) => {
    const newCodeByActionId = { ...codeByActionId };
    newCodeByActionId[id] = value;
    setCodeByActionId(newCodeByActionId);
  };

  const isLoading = (id) => loadingByActionId[id] || false;
  const setLoading = (id, value) => {
    const newLoadingByActionId = { ...loadingByActionId };
    newLoadingByActionId[id] = value;
    setLoadingByActionId(newLoadingByActionId);
  };

  return (
    <div className={`${styles['point-actions-slider']} point-actions-slider`}>
      { pointActions.length > MOBILE_SLIDES_COUNT && (
        <ClickableDiv className={`${styles.arrow} ${styles.left}`} onClick={onLeftArrowClick}>
          <img className={styles.mobile} src={arrowLeftMobileIcon} alt="previous" />
        </ClickableDiv>
      )}
      <Slider
        slidesToShow={MOBILE_SLIDES_COUNT}
        slidesToScroll={MOBILE_SLIDES_COUNT}
        className={`${styles.slider} ${styles.mobile}`}
        arrows={false}
        ref={(ref) => { mobileSliderRef.current = ref; }}
      >
        {pointActions.map((action) => (
          <PointActionWrapper
            key={action.id}
            action={action}
            clicked={isClicked(action.id)}
            setClicked={(value) => { setClicked(action.id, value); }}
            code={codeByActionId[action.id]}
            setCode={(value) => { setCode(action.id, value); }}
            loading={isLoading(action.id)}
            setLoading={(value) => { setLoading(action.id, value); }}
            birthday={birthday}
            setBirthday={setBirthday}
          />
        ))}
      </Slider>
      { pointActions.length > MOBILE_SLIDES_COUNT && (
        <ClickableDiv className={`${styles.arrow} ${styles.right}`} onClick={onRightArrowClick}>
          <img className={styles.mobile} src={arrowLeftMobileIcon} alt="next" />
        </ClickableDiv>
      )}

      <div className={styles.desktop}>
        { pointActions.map((action) => (
          <PointActionWrapper
            key={action.id}
            action={action}
            clicked={isClicked(action.id)}
            setClicked={(value) => { setClicked(action.id, value); }}
            code={codeByActionId[action.id]}
            setCode={(value) => { setCode(action.id, value); }}
            loading={isLoading(action.id)}
            setLoading={(value) => { setLoading(action.id, value); }}
            birthday={birthday}
            setBirthday={setBirthday}
          />
        ))}
      </div>
    </div>
  );
}

PointActionsSlider.propTypes = {
  pointActions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })).isRequired,
  pointActionWrapper: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]).isRequired,
};

export default PointActionsSlider;
